module.exports = __webpack_public_path__ + "img/2.5c77a411.gif";